import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../firebase/firebase.ts';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase.ts';

interface PrivateRouteProps {
    children: React.ReactNode;
    requireAdmin?: boolean;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, requireAdmin = false }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                if (requireAdmin) {
                    // Verificar se o usuário é admin
                    const userDoc = await getDoc(doc(db, 'users', user.uid));
                    const userData = userDoc.data();
                    setIsAuthorized(userData?.type === 'admin');
                } else {
                    setIsAuthorized(true);
                }
            } else {
                setIsAuthorized(false);
            }
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [requireAdmin]);

    if (isLoading) {
        return <div>Carregando...</div>;
    }

    if (!isAuthorized) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

export default PrivateRoute; 